import guest from './guest'
import logged from './logged'
import role from './role'

export {
  guest,
  logged,
  role
}



// WEBPACK FOOTER //
// ./src/router/middleware/index.js